import { useEffect } from 'react';
import gaService from '../../services/GoogleAnalyticsService';
import { getHeaderVersion } from '../../util/getHeaderVersion';

const useTrackHeaderImpression = () => {
    useEffect(() => {
        if (gaService.isInHeaderExperiment()) {
            gaService.trackEvent('header_impression', {
                header_version: getHeaderVersion(),
            });
        }
    }, []);
};

export default useTrackHeaderImpression;
